import { userService } from '../_services';

export const profiles = {
    namespaced: true,
    state: {
        all: {},
        active: null,
        ready: false
    },
    actions: {
        getProfiles({ commit }) {
            commit('getAllRequest');
            return new Promise((resolve, reject) => {

                userService.getProfiles()
                    .then(
                        profiles => {
                            commit('getAllSuccess', profiles);
                            resolve(profiles);
                        },
                        error => {
                            commit('getAllFailure', error);
                            reject(error);
                        }

                    );
            })
        },
        setActiveProfile({ commit, state }, active) {

            let data = {
                profiles: state.all,
                active: active
            };

            userService.setProfileSession(active.id);


            commit('getActiveProfile', data)


        },
        setNoActiveProfile({ commit, state }) {
            if(state.active === null) return;
            return new Promise((resolve, reject) => {

                userService.logoutProfileSession(state.active.id)
                    .then(
                        response => {
                            commit('getNoActiveProfile', state.all);
                            resolve(response);
                        },
                        error => {
                            commit('getAllFailure', error);
                            reject(error);
                        }
                    );
            })
        }
    },
    mutations: {
        getAllRequest(state) {
            state.all = { loading: true };
            state.active = null;
            state.ready = false;
        },
        getAllSuccess(state, profiles) {
            state.all = profiles['hydra:member'];
            state.active = null;
            state.ready = true;
        },
        getAllFailure(state, error) {
            state.all = { error };
            state.active = null;
            state.ready = false;
        },
        getActiveProfile(state, data) {
            state.all = data.profiles;
            state.active = data.active;
            state.ready = false;
        },
        getNoActiveProfile(state, data) {
            state.all = data;
            state.active = null;
            state.ready = false;
        }
    },
    getters: {
        showProfiles(state) {
            return state.all;
        },
        showProfileByIRI(state) {
            return iri => {
                return state.all.find(obj => obj['@id'] === iri)
            }
        },
        showProfilesByUser(state) {
            return userid => {
                return state.all.filter(obj => obj.user.id === userid)
            }
        },
        showProfilesByUserIRI(state) {
            return useriri => {
                return state.all.filter(obj => obj.user['@id'] === useriri)
            }
        },
        showActiveProfile(state) {
            return state.active;
        },
        isLoading(state) {
            return (state.all.loading);
        },
        isReady(state) {
            return (state.ready);
        }
    }
};
